import { render } from "./PopupInfo.vue?vue&type=template&id=2be81ad7&scoped=true"
import script from "./PopupInfo.vue?vue&type=script&lang=js"
export * from "./PopupInfo.vue?vue&type=script&lang=js"

import "./PopupInfo.vue?vue&type=style&index=0&id=2be81ad7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be81ad7"]])

export default __exports__